<div class="col-sm-12 p-1 rounded border">
    <div class="card m-0">
      <div class="p-1 backgroundColor">
        <label class="d-block"><b>Observação:</b></label>
        <div class="text-dark">
          <label class="d-block">- Tamanho máximo dos documentos, são de 2 Megabytes e somente PDF;</label>
          <label class="d-block">- Arquivos de Foto 3x4, somente JPG ou JPEG;</label>
          <label class="d-block">- <label class="asterisco">[*]</label> Campos com asterisco vermelho são obrigatórios.</label>
        </div>
      </div>
    </div>

    <div class="row m-1">
      <div class="col-sm-12 p-1">
        <fieldset class="form-group border rounded">
          <legend class="float-none w-auto">Documentos - Cotista</legend>

          <form [formGroup]="documentoCotistaForm">
            <div class="backgroundColor border rounded m-1">
            <div class="row m-1">
              <div class="col-sm-6">
                <label class="d-inline">- Isento de IR
                  <label class="asterisco">&nbsp;*</label>
                </label>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="input-group input-group-sm">
                    <div class="form-check form-check-inline" *ngFor="let isentoIR of listaRadioIsentoIR">
                      <input class="form-check-input" type="radio" formControlName="indIsentoIR"
                        [id]="'isentoIR.' + isentoIR.codigo" [value]="isentoIR.codigo" (change)="carregaUpload()" />
                      <label [for]="'isentoIR.' + isentoIR.codigo" class="form-check-label">{{ isentoIR.descricao }}</label>
                    </div>
                  </div>
                  <div *ngIf="hasRequired('indIsentoIR')" class="text-danger mensagemAlert">
                    {{ this.msgAlert }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row m-1">
              <div class="col-sm-6">
                <label class="d-inline">- Está Desempregado
                  <label class="asterisco">&nbsp;*</label>
                </label>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="input-group input-group-sm">
                    <div class="form-check form-check-inline" *ngFor="let desemp of listaRadioDesempregado">
                      <input class="form-check-input" type="radio" [id]="'desemp.' + desemp.codigo"
                        formControlName="indDesempregado" [value]="desemp.codigo" (change)="carregaUpload()" />
                      <label [for]="'desemp.' + desemp.codigo" class="form-check-label">{{ desemp.descricao }}</label>
                    </div>
                  </div>
                  <div *ngIf="hasRequired('indDesempregado')" class="text-danger mensagemAlert">
                    {{ this.msgAlert }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          </form>

          <div class="row m-1" [formGroup]="docs" *ngIf="docs">
            <div formArrayName="DocumentoCotista"
              *ngFor="let doc of docs.get('DocumentoCotista')['controls']; let i = index">
              <div class="row backgroundColor border rounded mb4 p-0" [formGroupName]="i">
                <div class="col-sm-6 p-1">
                  <label class="d-inline">
                    - {{ doc.value.descDoc }}
                    <label *ngIf="doc.value.obrigatorio==true" class="asterisco">&nbsp;*</label>
                  </label>
                </div>
                <div class="col-sm-6 p-1">
                  <div class="form-group">
                    <div class="col-auto mb-0 pb-0 pl-0 pr-0">
                      <div class="input-group mb-0">
                        <div class="custom-file mb-0">
                          <input type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                class="custom-file-input form-control-sm file-input"
                                id="inputGroupFile+{{i}}" #fileInput
                                (change)="uploadFile({files: fileInput.files, index: i, event: $event, value: doc.value.codDoc})"
                                [ngClass]="{ 'is-invalid': doc.value.fileBase64.errors?.required }" />
                          <div class="row mb-1">
                            <div class="form-group">
                              <div class="input-group input-group-sm">
                                <span class="input-group-text habilitar-cursor" (click)="fileInput.click()">Escolher arquivo</span>&nbsp;
                                <label class="label-text habilitar-cursor" for="inputGroupFile+{{i}}">{{ doc.value.nomeArquivo || "Nenhum arquivo escolhido"}}</label>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="doc.value.fileBase64.errors?.required" class="text-danger mensagemAlert">
                            {{ this.msgAlert }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </fieldset>
      </div>
    </div>

    <div class="row m-1">
      <div class="col-sm-12 text-start m-1">
        <button type="button"
                class="btn btn-sm btn-primary azulTopo"
                name="btnVoltar"
                data-toggle="button"
                (click)="btnRetornarTelaAnterior()">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;Voltar
        </button>
        &nbsp;&nbsp;&nbsp;
        <button class="btn btn-sm btn-primary azulTopo"
                name="Gravar"
                type="submit"
                [disabled]="habilitaBtnAvancar()"
                (click)="avancar()">
                Avançar&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
</div>
